import { render, staticRenderFns } from "./SlottedExpancionPanel.vue?vue&type=template&id=a2bf7452&"
import script from "./SlottedExpancionPanel.vue?vue&type=script&lang=js&"
export * from "./SlottedExpancionPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlottedExpancionPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VDivider,VExpansionPanel,VExpansionPanelContent})
